import React, {useState} from 'react';
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import {PersonOutlineOutlined} from "@mui/icons-material";
import {getAuth, signOut} from "firebase/auth";
import {Link, useNavigate} from "react-router";
import {Trans} from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Drawer, {drawerClasses} from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import UserManager, {useUser} from "../../managers/userManager/userManager";
import PhonelinkSetupIcon from '@mui/icons-material/PhonelinkSetup';
import UserCard from "../userCard/UserCard";

export const userPages = ['orders', 'saved-addresses', 'billing-info', 'designs'];
export const userPagesIcons = {
    'orders': <ReceiptOutlinedIcon/>,
    'saved-addresses': <MapOutlinedIcon/>,
    'billing-info': <ContactPageOutlinedIcon/>,
    'designs': <CollectionsOutlinedIcon/>
};

function UserNavItem(props) {
    const user = useUser();
    const navigate = useNavigate();
    const [anchorElMenu, setAnchorElMenu] = useState(null);
    const auth = getAuth();

    const handleOpenMenu = (event) => {
        setAnchorElMenu(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorElMenu(null);
    };

    const handleLogOut = () => {
        handleCloseMenu();
        signOut(auth).then(() => navigate('/'));
    }

    return (
        <>
            <IconButton
                size="large"
                aria-label="Language selector"
                aria-controls="lang-appbar"
                aria-haspopup="true"
                onClick={handleOpenMenu}
                color="inherit"
            >
                <PersonOutlineOutlined/>
            </IconButton>
            <Menu
                id="lang-appbar"
                anchorEl={anchorElMenu}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                open={Boolean(anchorElMenu)}
                onClose={handleCloseMenu}
                sx={{display: {xs: 'none', md: 'block'}}}
            >
                {user.uid ? <>
                    <UserCard handleCloseMenu={handleCloseMenu}/>
                    {UserManager.isAdmin() &&
                        <Link key="admin" to={'/admin'}
                              style={{textDecoration: 'none', color: 'inherit'}}>
                            <MenuItem onClick={handleCloseMenu} sx={{px: 4}}>
                                Admin
                            </MenuItem>
                        </Link>}
                    {userPages.map(key =>
                        <Link to={`/user/${key}`} key={key}
                              style={{textDecoration: 'none', color: 'inherit'}}><MenuItem onClick={handleCloseMenu}
                                                                                           sx={{px: 4}}>
                            <Trans i18nKey={`header.userMenu.${key}`}/>
                        </MenuItem>
                        </Link>)}
                    <MenuItem key="logOut" onClick={handleLogOut} sx={{px: 4}}>
                        <Trans i18nKey={`auth.logOut`}/>
                    </MenuItem>
                </> : <>
                    <Link key="signIn" to={'/sign-in'} style={{textDecoration: 'none', color: 'inherit'}}>
                        <MenuItem onClick={handleCloseMenu}>
                            <Trans i18nKey={`auth.signIn`}/>
                        </MenuItem>
                    </Link>

                    <Link key="signUp" to={'/sign-up'} style={{textDecoration: 'none', color: 'inherit'}}>
                        <MenuItem onClick={handleCloseMenu}>
                            <Trans i18nKey={`auth.register`}/>
                        </MenuItem>
                    </Link>
                </>
                }
            </Menu>
            <Drawer
                id="lang-appbar"
                keepMounted
                open={Boolean(anchorElMenu)}
                onClose={handleCloseMenu}
                sx={{
                    display: {xs: 'block', md: 'none'},
                    minWidth: '40%',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    [`& .${drawerClasses.paper}`]: {
                        minWidth: '200px',
                        backgroundImage: 'none',
                        backgroundColor: 'background.paper',
                    }
                }}
            >
                <Stack direction="row" sx={{p: 1, pb: 1, gap: 1}}>
                    <Stack
                        direction="row"
                        sx={{gap: 1, alignItems: 'center', flexGrow: 1, p: 1}}
                    >
                        {user.uid ? <UserCard mobil handleCloseMenu={handleCloseMenu}/>
                            : <Typography component="p" variant="h6">
                                <Trans i18nKey={`header.user`}/>
                            </Typography>}
                    </Stack>
                </Stack>
                <Divider/>
                <Stack sx={{flexGrow: 1}}>
                    {user.uid ? <Stack sx={{flexGrow: 1, p: 1, justifyContent: 'space-between'}}>
                            <List dense>
                                {UserManager.isAdmin() &&
                                    <ListItem key={"admin"} disablePadding sx={{display: 'block'}}
                                              onClick={handleCloseMenu}>
                                        <Link to={'/admin'} style={{textDecoration: 'none', color: 'inherit'}}>
                                            <ListItemButton>
                                                <ListItemIcon>{<PhonelinkSetupIcon/>}</ListItemIcon>
                                                <ListItemText primary={'Admin'}/>
                                            </ListItemButton>
                                        </Link>
                                    </ListItem>}
                                {userPages.map(key => <ListItem key={key} disablePadding sx={{display: 'block'}}
                                                                onClick={handleCloseMenu}>
                                    <Link to={`/user/${key}`} style={{textDecoration: 'none', color: 'inherit'}}>
                                        <ListItemButton>
                                            <ListItemIcon>{userPagesIcons[key]}</ListItemIcon>
                                            <ListItemText primary={<Trans i18nKey={`header.userMenu.${key}`}/>
                                            }/>
                                        </ListItemButton>
                                    </Link>
                                </ListItem>)}
                            </List>
                            <List dense>
                                <ListItem key={"logOut"} disablePadding sx={{display: 'block'}} onClick={handleLogOut}>
                                    <ListItemButton>
                                        <ListItemIcon>{<LogoutIcon/>}</ListItemIcon>
                                        <ListItemText primary={<Trans i18nKey={`auth.logOut`}/>
                                        }/>
                                    </ListItemButton>
                                </ListItem>
                            </List>
                        </Stack> :
                        <Stack sx={{flexGrow: 1, p: 1, justifyContent: 'space-between'}}>
                            <List dense>
                                <ListItem key={"signIn"} disablePadding sx={{display: 'block'}}
                                          onClick={handleCloseMenu}>
                                    <Link to={'/sign-in'} style={{textDecoration: 'none', color: 'inherit'}}>
                                        <ListItemButton>
                                            <ListItemIcon>{<LoginIcon/>}</ListItemIcon>
                                            <ListItemText primary={<Trans i18nKey={`auth.signIn`}/>
                                            }/>
                                        </ListItemButton>
                                    </Link>
                                </ListItem>
                                <ListItem key={"signUp"} disablePadding sx={{display: 'block'}}
                                          onClick={handleCloseMenu}>
                                    <Link to={'/sign-up'} style={{textDecoration: 'none', color: 'inherit'}}>
                                        <ListItemButton>
                                            <ListItemIcon>{<PersonAddAlt1Icon/>}</ListItemIcon>
                                            <ListItemText primary={<Trans i18nKey={`auth.register`}/>
                                            }/>
                                        </ListItemButton>
                                    </Link>
                                </ListItem>
                            </List>
                        </Stack>}
                    <Divider/>
                </Stack>
            </Drawer>
        </>
    )
        ;
}

export default UserNavItem;
